import { ByteUnits, FormattedBytes } from './types'

// community solution from https://stackoverflow.com/a/18650828/4267716
export function formatBytes(bytes: number, decimals = 2): FormattedBytes {
  if (bytes === 0) return '0 Bytes'

  // Using the "1 kB == 1000 bytes" rather than "1 kB == 1024 bytes"
  // standard as the latter was causing differences with the file
  // sizes calculated by OSs. Furthermore, SI ("1 kB == 1000 bytes")
  // standard is the one IEC refers to:
  // https://physics.nist.gov/cuu/Units/binary.html
  const k = 1000
  const dm = decimals < 0 ? 0 : decimals
  const sizes = [
    'Bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB',
  ] as ByteUnits[]

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
